/**
 *
 * playback-page sagas
 *
 */

import {
    all, put, call, take, takeLatest, select,
} from 'redux-saga/effects';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { LOAD_PLAYBACK_PAGE } from './playback-page-constants';
import { makeSelectClipId } from 'data/clip/clip-selectors';
import { makeSelectTopicData } from 'data/topic/topic-selectors';
import { makeSelectListItems } from 'data/list/list-selectors';
import { loadTopic } from 'data/topic/topic-actions';
import { loadList } from 'data/list/list-actions';
import { loadClip, setClipData } from 'data/clip/clip-actions';
import { LOAD_TOPIC_SUCCESS } from 'data/topic/topic-constants';
import { makeSelectDefaultTopic } from 'data/config/runtime-config-selectors';

export function* getClipData(contentId) {

    const currentClipId = yield select(makeSelectClipId());
    const currentListItems = yield select(makeSelectListItems());

    if (currentClipId === contentId) {

        return;

    }

    const clipDataInList = currentListItems.find(item => item.id === contentId);

    if (clipDataInList) {

        yield put(setClipData(clipDataInList));

    } else {

        yield put(loadClip(contentId));

    }

}

export function* getTopicData(topic) {

    const defaultTopicId = yield select(makeSelectDefaultTopic());
    const topicId = topic || defaultTopicId;
    const currentTopicData = yield select(makeSelectTopicData());
    const currentTopicId = currentTopicData.id || currentTopicData.slug;

    if (topicId === currentTopicId) {

        return;

    }

    yield put(loadTopic(topicId));
    const action = yield take(LOAD_TOPIC_SUCCESS);
    const advancedCriteria = _get(action, 'data.advancedCriteria', '');
    const selectionSlug = _get(action, 'data.selection[0].slug', '');
    yield put(loadList(selectionSlug, advancedCriteria));

}

export function* bootstrapPage(action) {

    const contentId = action.contentId;
    const topicId = action.topicId;

    yield all([
        call(getClipData, contentId),
        call(getTopicData, topicId),
    ]);

}

/**
 * Root saga manages watcher lifecycle
 */
export default function* playbackPage() {

    // Watches for LOAD_PLAYBACK_PAGE action and calls bootstrapPage when one comes in.
    // By using `takeLatest` only the result of the latest API call is applied.
    // It returns task descriptor (just like fork) so we can continue execution
    // It will be cancelled automatically on component unmount
    yield takeLatest(LOAD_PLAYBACK_PAGE, bootstrapPage);

}
